package com.iregained.site.components.sections.clinics.sections

import com.iregained.site.region.Region
import com.iregained.site.region.RegionConfig
import com.iregained.site.utils.Res

data class ClinicsData(
    val companyTag: String,
    val companyName: String, val address: String, val phone: String, val email: String, val websiteUrl: String
)

data class ClinicsLocatorData(
    val heroSectionId: String? = "clinics-hero-section",
    val listSectionId: String? = "clinics-list-section",
    val ctaSectionId: String? = "clinics-cta-section",
    val headline: String,
    val subtitle: String,
    val activeClinics: List<ClinicsData>,

    // CMS Configurables: Assets
    val heroBackgroundImage: String = Res.Images.Resources.BANNER,

    // CMS Configurables: Tool UI Strings
    val searchPlaceholder: String = "🔍 Search by city, state, or clinic name...",
    val locationsFoundText: String = "Equipped Clinics Found",
    val noResultsMessage: String = "We couldn't find a clinic matching that search.",
    val emptyRegionMessage: String = "We are currently expanding our network in this region. Please contact us to find alternative access to the MyHand<sup>®</sup> System.",

    // CMS Configurables: Button Strings
    val directionsButtonText: String = "Get Directions",
    val websiteButtonText: String = "Visit Clinic Website",

    // CMS Configurables: CTA Section (MASSIVE UX SHIFT HERE)
    val ctaHeadline: String = "Don't see your local clinic listed?",
    val ctaDescription: String = "We are constantly expanding our network. Let us know where you receive therapy, and we will reach out to your provider to introduce them to the MyHand<sup>®</sup> System.",
    val ctaButtonText: String = "Nominate Your Clinic",
    val ctaLink: String = "/contact"
)

// ==========================================
// REGION SWITCHBOARD
// ==========================================
private val allClinics = mapOf(
    Region.INDIA to listOf(
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "PhysMedRehab",
            "Jayanagar Bengaluru, Karnataka, India",
            "+91 97421 28803",
            "enquiry@physmedrehab.in",
            "https://physmedrehab.in/"
        ),
//        ClinicsData(
//            "MyHand<sup>®</sup> Equipped",
//
//            "Mumbai Stroke Recovery Institute",
//            "Mumbai, Maharashtra, India",
//            "+91 98765 11111",
//            "contact@mumbairecovery.in",
//            "https://mumbairecovery.in"
//        ),
//        ClinicsData(
//            "MyHand<sup>®</sup> Equipped",
//            "Chennai Advanced Physiotherapy",
//            "Chennai, Tamil Nadu, India",
//            "+91 98765 22222",
//            "appointments@chennaipt.in",
//            "https://chennaipt.in"
//        )
    ), Region.US to listOf(
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "UofL Health – Frazier Rehabilitation Institute",
            "220 Abraham Flexner Way, Louisville, KY 40202, United States",
            "+1 502-582-7400",
            "",
            "https://uoflhealth.org/locations/frazier-rehabilitation-institute/?utm_source=GMBSocialClimb&utm_medium=UofLHealth%E2%80%93FrazierRehabilitationInstitute"
        ),
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "St. John Medical Center - Westlake Family Health Building",
            "26908 Detroit Road, Suite 300 Westlake, Ohio 44145",
            "",
            "",
            "https://www.uhhospitals.org/locations/uh-st-john-medical-center"
        ),
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "UT San Antonio",
            "One UTSA Circle, San Antonio, TX 78249",
            "+1 210-458-4011",
            "",
            "https://www.utsa.edu/"
        ),
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "University of Cincinnati Medical Campus",
            "2600 Clifton Ave. Cincinnati, OH 45221",
            "",
            "",
            "https://www.uc.edu/"
        )
    ), Region.CANADA to listOf(
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "MapleCare Physiotherapy & Neuro Rehab Center",
            "1173 Wellington St W, Ottawa ON K1Y 2Y9",
            "+1 (613) 695-1111",
            "info@maplecarephysiotherapy.com",
            "https://maplecarephysiotherapy.com/"
        ),
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "Walk It Off Wellness Center",
            "16775 Yonge St, Newmarket, ON L3X 2P8",
            "+1 (289) 340-0072",
            "info@walkitoffrecovery.org",
            "https://walkitoffrecovery.org/"
        ),
        ClinicsData(
            "MyHand<sup>®</sup> Equipped",
            "Royal Victoria Regional Health Centre (RVH)",
            "201 Georgian Dr, Barrie, ON L4M 6M2",
            "+1 (705) 728-9802",
            "patientexperience@rvh.on.ca",
            "https://www.rvh.on.ca/"
        ),
    )
)

val defaultClinicsData: ClinicsLocatorData
    get() {
        val activeRegion = RegionConfig.currentRegion
        val regionalClinics = allClinics[activeRegion] ?: emptyList()

        return ClinicsLocatorData(
            headline = "Find a Certified MyHand<sup>®</sup> Clinic",
            subtitle = "Start your recovery journey today. Locate a specialized neuro-rehabilitation provider near you offering the MyHand<sup>®</sup> System.",
            activeClinics = regionalClinics
        )
    }